import { FontAwesomeIcon } from '@vr/lib';

export default FontAwesomeIcon;
